import {
  Box,
  Button,
  Card,
  Flex,
  Group,
  rem,
  Stack,
  Text,
} from "@mantine/core";
import ApprovalInfoCard from "modules/term-deposit/components/ApprovalInfoCard";
import { useTranslation } from "react-i18next";
import { toCurrency } from "utils/common";
import { v4 as uuidv4 } from "uuid"; // Import uuid

const InfoItem = ({
  label,
  value,
  bold = false,
}: {
  label: string;
  value: string;
  bold?: boolean;
}) => (
  <Group align="center" spacing={8}>
    <Text fw={400} color="#6D6D6D" fz={16} miw={160}>
      {label}
    </Text>
    <Text fw={bold ? 700 : 400} fz={14}>
      {value}
    </Text>
  </Group>
);

export const TermLoanDetail = ({
  onNext,
  onCancel,
}: {
  onNext: () => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();
  const data = [
    { label: t("FULL_NAME"), value: "NGUYEN VAN A", bold: true },
    { label: t("DATE_OF_BIRTH"), value: "01/01/2000" },
    { label: t("ID_CARD_/_CITIZEN_ID"), value: t("6_MONTHS_-_10%/YEAR") },
    { label: t("ISSUE_DATE"), value: toCurrency(105000000) },
    { label: t("TELEPHONE"), value: t("INTEREST_ROLLED_OVER_TO_PRINCIPAL") },
    { label: t("PERMANENT_ADDRESS"), value: "123 NKKKN" },
  ];
  return (
    <Box>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          borderLeft: "3px solid #246CF9",
          paddingLeft: "10px",
          margin: "20px 0",
        }}
      >
        <Text fw={600} size="24px">
          {t("LOAN_INFORMATION_CONFIRMATION")}
        </Text>
      </Box>
      <Flex align="start" justify="space-between" gap={24}>
        <Card
          shadow="sm"
          radius="md"
          // w={929}
          // h={800}
          sx={{
            flex: "1",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <Stack spacing={24}>
            <Text fw={600} fz={20}>
              {t("REQUEST_INFORMATION")}
            </Text>

            {data.map((item, index) => (
              <InfoItem key={uuidv4()} {...item} />
            ))}

            <Text fw={600} fz={20}>
              {t("REQUEST_INFORMATION")}
            </Text>

            {data.map((item, index) => (
              <InfoItem key={uuidv4()} {...item} />
            ))}
          </Stack>
        </Card>
        <Box>
          <ApprovalInfoCard />
        </Box>
      </Flex>

      {/* Footer luôn ở cuối */}
      <Group position="center" mt={rem(20)}>
        <Box
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            width: "calc(100% - var(--mantine-navbar-width, 0px))",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "right",
            gap: "10px",
            boxShadow: "0px 5px 15px 0px #00000026",
            height: "76px",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <Button
            sx={() => ({
              width: "160px",
              background: "#F4F4F6",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 600,
              color: "black",
              ":hover": {
                background: "#F4F4F6",
                color: "black",
              },
            })}
            mr="xs"
            type="reset"
            onClick={onCancel}
          >
            {t("CANCEL")}
          </Button>
          <Button
            sx={() => ({
              width: "160px",
              color: "white",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 400,
              ":hover": {
                color: "white",
              },
              background: "#2A81D0",
            })}
            type="submit"
            onClick={onNext}
          >
            {t("NEXT")}
          </Button>
        </Box>
      </Group>
    </Box>
  );
};
